<template>
  <div class="edit">
    <div class="wrp">
      <div class="ant-upload ant-upload-drag main-col drag-wrap">
        <div
          :class="isCut?'prevView':'mask'"
          ondragstart="return false;"
          ref="odiv"
          v-scroll="scroll"
          @mousedown="canDrag && drag($event)"
          @mousewheel.prevent
        >
          <div class="before" :style="{height:`${rule.height}px`}"></div>
          <div
            class="mask-shadow"
            :style="{borderWidth: isCut?``:`${(808 - rule.height) /2}px ${(944 - rule.width) / 2}px`}"
          >
            <div
              :class="isCut?'sure-wrap':''"
              :style="{width:`${rule.width}px`,height:`${rule.height}px`}"
            >
              <div class="horn">
                <div class="lt"></div>
                <div class="rt"></div>
                <div class="rb"></div>
                <div class="lb"></div>
              </div>
              <div class="wpx">{{actualRuleInfo.width||rule.width}}px</div>
              <div class="hpx">{{actualRuleInfo.height||rule.height}}px</div>
              <div v-if="rule.widthmm" class="wmm">{{rule.widthmm}}mm</div>
              <div v-if="rule.heightmm" class="hmm">{{rule.heightmm}}mm</div>
              <canvas v-show="!canDrag" id="cutPic" :width="rule.width" :height="rule.height"></canvas>
            </div>
          </div>
          <div class="after" :style="{width:`${rule.width}px`}"></div>
        </div>
        <img
          v-show="canDrag"
          ref="pic"
          :src="url"
          id="pic"
          ondragstart="return false;"
          class="upload-img"
          alt
        />
      </div>
      <div class="sidebar-col">
        <sideBar title="保存" iconType="download">
          <div class="sidebar-con">
            <a-button @click="showPayPopFn" class="btn" type="primary" block>保存</a-button>
            <router-link :to="{ path: '/cutPic' }">
              <a-button class="btn" block>重新上传</a-button>
            </router-link>
          </div>
        </sideBar>
        <sideBar title="调整裁剪" iconType="edit">
          <div class="sidebar-con">
            <a-row type="flex">
              <a-col class="flex-center" :span="4">
                <span style>缩放</span>
              </a-col>
              <a-col :span="16">
                <a-slider
                  :min="scaleValMin"
                  :max="scaleValMax"
                  :disabled="isCut"
                  :step="0.01"
                  v-model="scaleVal"
                />
              </a-col>
              <a-col class="flex-center" :span="4">
                <span style="marginLeft: 16px">{{scaleVal.toFixed(2)}}</span>
              </a-col>
            </a-row>
            <a-row class="toolBtn-wrp" type="flex">
              <a-button @click="reset">重做</a-button>
              <a-button type="primary" @click="cutFn" :disabled="isCut">裁剪</a-button>
            </a-row>
          </div>
        </sideBar>
      </div>
    </div>
    <payPop
      v-if="showPayPop"
      :cancel="cancel"
      :isCut="true"
      picType="tailoring"
      :isVisible="showPayPop"
      :specId="rule.specId"
    ></payPop>
  </div>
</template>

<script>
import sideBar from "@/components/sidebar.vue";
import payPop from "@/components/payPop.vue";
import { cutPic } from "@/utils/api";
export default {
  data() {
    return {
      // rotateVal: 0,
      scaleVal: 1,
      scaleValMax: 1.5,
      scaleValMin: 1,
      showPayPop: false,
      isCut: false,
      canDrag: true,
      handleDataObj: { x: 0, y: 0 },
      imgW: 0,
      imgH: 0,
      originalImgInfo: {
        w: 0,
        h: 0
      },
      rule: {
        width: 0,
        height: 0,
        heightmm: "",
        widthmm: "",
        specId: null
      },
      actualRuleInfo: {},
      url: this.$store.state.url || sessionStorage.getItem("url")
    };
  },
  metaInfo() {
    return {
      title: "图片裁剪丨证件照片在线裁剪修改大小尺寸工具",
      meta: []
    };
  },
  components: {
    sideBar,
    payPop
  },
  beforeCreate() {
    if (
      !JSON.parse(sessionStorage.getItem("ruleItemInfo")) ||
      !sessionStorage.getItem("url")
    ) {
      this.$router.replace(`/cutPic`);
    }
  },
  mounted() {
    this.rule = {
      width: JSON.parse(sessionStorage.getItem("ruleItemInfo")).width_px,
      height: JSON.parse(sessionStorage.getItem("ruleItemInfo")).height_px,
      heightmm: JSON.parse(sessionStorage.getItem("ruleItemInfo")).height_mm,
      widthmm: JSON.parse(sessionStorage.getItem("ruleItemInfo")).width_mm,
      specId: JSON.parse(sessionStorage.getItem("ruleItemInfo")).spec_id
    };
    this.handleRuleInfo(this.rule);
    this.handlePicSize();
    this.getKuangCoordinate();
  },
  watch: {
    scaleVal(val) {
      this.$refs.pic.style.left =
        this.$refs.pic.offsetLeft -
        (this.imgW * this.scaleVal - this.$refs.pic.width) / 2 +
        "px";
      this.$refs.pic.style.top =
        this.$refs.pic.offsetTop -
        (this.imgH * this.scaleVal - this.$refs.pic.height) / 2 +
        "px";
      let imgObj = {
        left: this.$refs.pic.offsetLeft,
        top: this.$refs.pic.offsetTop
      };
      this.$refs.pic.width = this.imgW * this.scaleVal;
      this.$refs.pic.height = this.imgH * this.scaleVal;
      this.condition(imgObj, this.$refs.odiv, {
        odivW: this.$refs.pic.width,
        odivH: this.$refs.pic.height
      });
      this.getImgCoordinate();
    }
  },
  methods: {
    handleRuleInfo({ width, height }) {
      if (width > 944 || height > 808) {
        this.actualRuleInfo = Object.assign({}, this.rule);
        this.rule.width = this.rule.width / 3;
        this.rule.height = this.rule.height / 3;
      }
    },
    handlePicSize() {
      this.$refs.pic.addEventListener("load", () => {
        let { width: w, height: h } = this.$refs.pic;
        let { width: ruleW, height: ruleH } = this.rule;
        this.originalImgInfo = {
          w,
          h
        };
        if (ruleW / ruleH >= w / h) {
          this.$refs.pic.width = this.rule.width;
          this.imgW = this.rule.width;
          this.imgH = this.$refs.pic.height;
        } else if (w / h > ruleW / ruleH) {
          this.$refs.pic.height = this.rule.height;
          this.imgW = this.$refs.pic.width;
          this.imgH = this.rule.height;
        }
        this.getImgCoordinate();
      });
    },
    cancel() {
      this.showPayPop = false;
    },
    getKuangCoordinate() {
      let { width, height } = this.rule;
      let w = width / 2,
        h = height / 2;
      this.handleDataObj.kuangCoordinate = {
        lt: {
          x: -w,
          y: h
        },
        rt: {
          x: w,
          y: h
        },
        lb: {
          x: -w,
          y: -h
        },
        rb: {
          x: w,
          y: -h
        }
      };
    },
    getImgCoordinate() {
      let {
        imgW: width,
        imgH: height,
        handleDataObj: { x, y }
      } = this;
      let w = (width * this.scaleVal) / 2,
        h = (height * this.scaleVal) / 2;
      this.handleDataObj.imgCoordinate = {
        lt: {
          x: -w + x,
          y: h + y
        },
        rt: {
          x: w + x,
          y: h + y
        },
        lb: {
          x: -w + x,
          y: -h + y
        },
        rb: {
          x: w + x,
          y: -h + y
        }
      };
    },
    showPayPopFn() {
      if (this.isCut) {
        let c = document.getElementById("cutPic");
        let file = c.toDataURL();

        let data = {
          file: file
        };
        if (JSON.parse(sessionStorage.getItem("ruleItemInfo")).spec_id) {
          data.spec_id = JSON.parse(
            sessionStorage.getItem("ruleItemInfo")
          ).spec_id;
        } else {
          let {
            width_px: width_pix,
            height_px: high_pix,
            file_size_max,
            file_size_min,
            dpi
          } = JSON.parse(sessionStorage.getItem("ruleItemInfo"));
          Object.assign(data, {
            width_pix,
            high_pix,
            file_size_max,
            file_size_min,
            dpi
          });
        }
        cutPic(data).then(res => {
          sessionStorage.setItem("image_key", res.image_key);
          this.showPayPop = true;
        });
      } else {
        this.$message.error("请裁剪后保存!");
      }
    },
    cutFn() {
      this.isCut = true;
      this.canDrag = false;
      this.getImgCoordinate();
      this.drawImage();
    },
    drawImage() {
      let c = document.getElementById("cutPic");
      let cxt = c.getContext("2d");
      cxt.clearRect(0, 0, c.width, c.height);
      let {
        handleDataObj: { imgCoordinate, kuangCoordinate },
        originalImgInfo: { w, h },
        rule: { width, height },
        imgW,
        imgH,
        scaleVal: scale
      } = this;
      let imgl =
        ((kuangCoordinate.lt.x - imgCoordinate.lt.x) / scale) * (w / imgW);
      let imgt =
        ((imgCoordinate.lt.y - kuangCoordinate.lt.y) / scale) * (h / imgH);
      let qieW = (width / scale) * (w / imgW);
      let qieH = (height / scale) * (h / imgH);
      cxt.drawImage(
        document.getElementById("pic"),
        imgl,
        imgt,
        qieW,
        qieH,
        0,
        0,
        width,
        height
      );
    },
    reset() {
      this.isCut = false;
      this.canDrag = true;
      // this.rotateVal = 0;
      this.scaleVal = 1;
      this.$refs.pic.width = this.imgW;
      this.$refs.pic.height = this.imgH;
      this.$nextTick(_ => {
        this.$refs.pic.style.left = `calc(50% - ${this.imgW / 2}px)`;
        this.$refs.pic.style.top = `calc(50% - ${this.imgH / 2}px)`;
      });
      this.handleDataObj.x = 0;
      this.handleDataObj.y = 0;
    },
    condition(imgObj, odiv, oDivObj) {
      let { odivW, odivH } = oDivObj;
      // [左,右,上,下]溢出处理 condition:溢出判断条件 imgVal：溢出限制图片移动的left top
      let isOutArr = [
        {
          condition:
            this.handleDataObj.x >
            odivW / 2 - this.handleDataObj.kuangCoordinate.rt.x,
          imgVal: [
            "left",
            odiv.offsetWidth / 2 - this.handleDataObj.kuangCoordinate.rt.x
          ]
        },
        {
          condition:
            -this.handleDataObj.x >
            odivW / 2 - this.handleDataObj.kuangCoordinate.rt.x,
          imgVal: [
            "left",
            this.handleDataObj.kuangCoordinate.rt.x +
              odiv.offsetWidth / 2 -
              odivW
          ]
        },
        {
          condition:
            -this.handleDataObj.y >
            odivH / 2 - this.handleDataObj.kuangCoordinate.rt.y,
          imgVal: [
            "top",
            odiv.offsetHeight / 2 - this.handleDataObj.kuangCoordinate.rt.y
          ]
        },
        {
          condition:
            this.handleDataObj.y >
            odivH / 2 - this.handleDataObj.kuangCoordinate.rt.y,
          imgVal: [
            "top",
            this.handleDataObj.kuangCoordinate.rt.y +
              odiv.offsetHeight / 2 -
              odivH
          ]
        }
      ];
      isOutArr.forEach((item, idx) => {
        let { condition, imgVal } = item;
        if (condition) {
          imgObj[imgVal[0]] = imgVal[1];
          this.handleDataObj.x = -(
            odiv.offsetWidth / 2 -
            odivW / 2 -
            imgObj.left
          );
          this.handleDataObj.y = odiv.offsetHeight / 2 - odivH / 2 - imgObj.top;
        }
      });
      this.$refs.pic.style.left = imgObj.left + "px";
      this.$refs.pic.style.top = imgObj.top + "px";
      // return imgObj;
    },
    scroll(direction) {
      if (this.canDrag) {
        // 鼠标滚轮滚动 direction:true为down false为up
        direction
          ? this.scaleVal > this.scaleValMin && (this.scaleVal -= 0.01)
          : this.scaleVal < this.scaleValMax && (this.scaleVal += 0.01);
      }
    },
    drag(el) {
      let odiv = el.currentTarget; //获取当前元素
      let imgEl = el.currentTarget.nextElementSibling; //获取图片元素
      let odivW = imgEl.width;
      let odivH = imgEl.height;
      imgEl.style.position = "absolute";
      // 首次点击图片默认居中
      imgEl.style.left || (imgEl.style.left = `calc(50% - ${odivW / 2}px)`);
      imgEl.style.top || (imgEl.style.top = `calc(50% - ${odivH / 2}px)`);
      //算出鼠标相对元素的位置
      let disX = el.clientX - imgEl.offsetLeft;
      let disY = el.clientY - imgEl.offsetTop;
      odiv.onmousemove = e => {
        //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
        // let left = e.clientX - disX;
        // let top = e.clientY - disY;
        let imgObj = { left: e.clientX - disX, top: e.clientY - disY };
        // console.log("imgObj::", imgObj);
        this.handleDataObj.x = -(
          odiv.offsetWidth / 2 -
          odivW / 2 -
          imgObj.left
        );
        this.handleDataObj.y = odiv.offsetHeight / 2 - odivH / 2 - imgObj.top;
        // 限制图片溢出处理
        this.condition(imgObj, odiv, { odivW, odivH });
        //移动当前元素
      };
      odiv.onmouseup = e => {
        odiv.onmousemove = null;
        odiv.onmouseup = null;
      };
    }
  }
};
</script>
<style scoped>
.edit {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}
.drag-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
.upload-img {
  flex-shrink: 0;
}
.sidebar-con {
  padding: 14px 15px;
}
.btn {
  height: 40px;
  margin-bottom: 8px;
}
.toolBtn-wrp {
  justify-content: space-between;
  margin-top: 25px;
}
.toolBtn-wrp button {
  width: 99px;
  height: 30px;
}
.prevView,
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}

.mask-shadow {
  width: 100%;
  height: 100%;
  border: solid rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  color: #ffffff;
  box-shadow: 10px 10px 5px #888888;
}
.prevView .mask-shadow {
  border-color: transparent;
  color: #2a292e;
}
.mask .before,
.mask .after {
  display: block;
  box-sizing: border-box;
  position: absolute;
  z-index: 200;
}
.mask .before {
  width: 100%;
  border-top: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  top: 50%;
  transform: translateY(-50%);
  transform: -webkit-translateY(-50%);
}
.mask .after {
  height: 100%;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  left: 50%;
  transform: translateX(-50%);
  transform: -webkit-translateX(-50%);
}
.wpx,
.hpx,
.wmm,
.hmm {
  font-size: 12px;
  position: absolute;

  padding: 0 5px;
}
.sure-wrap .wpx,
.sure-wrap .hpx,
.sure-wrap .wmm,
.sure-wrap .hmm {
  background: #ebedf0;
}
.wpx,
.wmm {
  left: 50%;
  transform: translateX(-50%);
}
.hpx,
.hmm {
  top: 50%;
  transform: translateY(-50%) rotate(-90deg);
}
.wpx {
  top: -20px;
}
.wmm {
  bottom: -24px;
}
.hpx {
  left: -14px;
  transform: translateX(-50%) rotate(-90deg);
}
.hmm {
  right: -16px;
  transform: translateX(50%) rotate(-90deg);
}
</style>
